import React from 'react'
import { Droppable } from 'react-beautiful-dnd'
import Grid from '@mui/material/Grid'

const DroppableCard = ({ id, card, styles }) => {

  const cardStyle = (styles, card) => { //eslint-disable-line no-unused-vars
    let result;
    if (card.show) {
      result = card.correct ? styles.correctCard : styles.wrongCard;
    } else {
      result = styles.cardRoot;
    }
    return result;
  }

  const styleCard = cardStyle(styles, card);

  return (
    <Grid item xs={6}>
      <div key={id} style={styleCard}>
        <Droppable key={id} droppableId={id} direction='horizontal'>
          {(provided, snapshot) => (
            <Grid
              container
              direction={"row"}
              justifyContent={"space-around"}
              alignContent={"space-around"}
            >
              <Grid item xs={12}>
                <img src={card.src} width="100%" alt="" />
                {card.value ?
                  <div
                    key={id}
                    className={"dropBoxSelected"}
                    ref={provided.innerRef}
                  >
                    {card.heading}
                    {provided.placeholder}
                  </div>
                  :
                  <div
                    key={id}
                    className={"dropBox"}
                    ref={provided.innerRef}
                  >
                    {card.heading}
                    {provided.placeholder}
                  </div>
                }
              </Grid>
            </Grid>

          )}
        </Droppable>
      </div >
    </Grid>
  )
}

export default DroppableCard
